import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Backspace({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M6.82207 4C6.62784 4 6.44647 4.09198 6.33873 4.24511L1.09756 11.6947C0.96748 11.8796 0.96748 12.1204 1.09756 12.3053L6.33873 19.7549C6.44647 19.908 6.62784 20 6.82207 20H23.4191C23.7399 20 24 19.7536 24 19.4496V4.55044C24 4.24644 23.7399 4 23.4191 4H6.82207ZM19.1189 16.0233L16 12.9044L12.8811 16.0233L12.0478 15.1899L15.1667 12.0711L12.0478 8.9522L12.8811 8.11887L16 11.2377L19.1189 8.11887L19.9522 8.9522L16.8333 12.0711L19.9522 15.1899L19.1189 16.0233Z"
        fill={iconColor}
      />
    </Svg>
  );
}
